import authInstance from "../Interceptor/interceptor";

export const addSecurityOfficerEffect = (formData) => {
  return authInstance.post("/security/insertsecurity", formData);
};

export const deleteSecurityOfficerEffect = (id) => {
  return authInstance.delete(`/security/deletesecurity/${id}`);
};

export const editSecurityOfficerEffect = (id, formData) => {
  return authInstance.put(`/security/updatesecurity/${id}`, formData);
};
export const viewSecurityOfficerEffect = (id) => {
  return authInstance.get(`/security/getSecurity?security_id=${id}`);
};

export const listSecurityOfficerEffect = (payload) => {
  const { pageNo, pagesize, pagination_required, search, search_by } = payload;
  return authInstance.get(
    `/security/securityGetAll?pageNo=${pageNo}&pagesize=${pagesize}&pagination_required=${pagination_required}&search_by=${search_by}&search=${search}`
  );
};
